<template>
    <div>

    <div class="row">
        <div class="col">
            <div class="card bg-soft-success">
                <div class="card-body text-center">
                    <i class=""></i>
                    <h1 class="fw-semibold mb-1 text-success">{{ shipment_last }}</h1>
                    <div class="fw-medium">Shipment last 30 days</div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card bg-soft-info">
                <div class="card-body text-center">
                    <i class=""></i>
                    <h1 class="fw-semibold mb-1 text-info">{{ shipment_updated_eta }}</h1>
                    <div class="fw-medium">Shipments with "Updated ETA"</div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card bg-soft-danger">
                <div class="card-body text-center">
                    <i class=""></i>
                    <h1 class="fw-semibold mb-1 text-danger">{{ shipment_arriving }}</h1>
                    <div class="fw-medium">Shipments "Arriving within 10 days</div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card bg-soft-warning">
                <div class="card-body text-center">
                    <i class=""></i>
                    <h1 class="fw-semibold mb-1 text-warning">{{ shipment_wating_pickup }}</h1>
                    <div class="fw-medium">Shipments "Awaiting Pickup"</div>
                </div>
            </div>
        </div>
    </div>

    
<div class="row">
    <div class="col-lg-12 col-md-12">
        <div class="card panel ">
            <div class="card-header headnbtn">
                <div class="d-flex align-items-center justify-content-between">
                    <h5 class="card-title mb-0 flex-grow-1">Shipments</h5>
                    <!--<div class="flex-shrink-0">
                        <a href="#" class="btn btn-primary btn-sm" id="qfilter"><i class="ri-filter-line align-middle me-1"></i> Filter</a>
                    </div>-->
                    <div class="input-group custom-input" style="max-width: 450px">
                                    <!-- <button class="btn btn-light dropdown-toggle for-order" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="border: 1px solid #ced4da;">All <i class="fas fa-angle-down"></i></button> -->
                                    <select v-model="selectFilter" class="form-select select-all">
                                        <option value="1">All</option>
                                        <option value="2">Order Number</option>
                                        <option value="3">Shipment ID</option>
                                        <option value="4">Customer</option>
                                        <option value="5">Vendor</option>
                                        <option value="6">Shipment Method</option>
                                        <option value="7">Carrier</option>
                                        <option value="8">ETD</option>
                                        <option value="9">ETA</option>

                                    </select>
                                    <!-- <ul class="dropdown-order dropdown-menu">
                                        <li><a class="dropdown-item" href="javascript: void(0);">All</a></li>
                                        <li><a class="dropdown-item" href="javascript: void(0);">Order Number</a></li>
                                        <li><a class="dropdown-item" href="javascript: void(0);">Shipment ID</a></li>
                                        <li><a class="dropdown-item" href="javascript: void(0);">Customer</a></li>
                                        <li><a class="dropdown-item" href="javascript: void(0);">Vendor</a></li>
                                        <li><a class="dropdown-item" href="javascript: void(0);">Shipment Method</a></li>
                                        <li><a class="dropdown-item" href="javascript: void(0);">Carrier</a></li>
                                        <li><a class="dropdown-item" href="javascript: void(0);" id="etd">ETD</a></li>
                                        <li><a class="dropdown-item" href="javascript: void(0);" id="eta">ETA</a></li>
                                        <li><a class="dropdown-item" href="javascript: void(0);" id="lfd">LFD</a></li>
                                    </ul> -->

                                    <template v-if="selectFilter == 1">
                                        <input type="text" v-model="filterForm.search" class="form-control" placeholder="Search...">
                                    </template>

                                    <template v-if="selectFilter == 2">
                                        <input class="form-control" v-model="filterForm.order_number" type="text" placeholder="Order Number" >
                                    </template>

                                    <template v-if="selectFilter == 3">
                                       <input class="form-control" v-model="filterForm.shipment_number" type="text" placeholder="Shipment Number" >
                                    </template>

                                    <template v-if="selectFilter == 4">
                                        <v-select label="company_name" placeholder="Select Customer" v-model="filterForm.customer_id" :filterable="false" :options="options" :reduce="(option) => option.id" @search="onSearch">
                                        <template slot="no-options">
                                        Search Customer
                                        </template>
                                        <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.company_name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.company_name }}
                                        </div>
                                        </template>
                                    </v-select>
                                    </template>

                                    <template v-if="selectFilter == 5">
                                        <v-select label="company_name" placeholder="Select Vendor" v-model="filterForm.vendor_id" :filterable="false" :options="optionsVendor" :reduce="(option) => option.id" @search="onVendorSearch">
                                        <template slot="no-options">
                                        Search Vendor
                                        </template>
                                        <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.company_name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.company_name }}
                                        </div>
                                        </template>
                                    </v-select>
                                    </template>

                                    <template v-if="selectFilter == 6">
                                        <select class="form-control" v-model="filterForm.ship_method">
                                            <option :value="null">Select Shipment Method </option>
                                            <option value="1">Air</option>
                                            <option value="2">Occean</option>
                                            
                                        </select>
                                    </template>
                                    <template v-if="selectFilter == 7">
                                        <input type="text" class="form-control" v-model="filterForm.carrier" placeholder="Carrier...">
                                    </template>
                                    <template v-if="selectFilter == 8">
                                        <select class="form-control" v-model="filterForm.search_by_etd" @change="searchDate()">
                                            <option :value="null">Time Frame</option>
                                            <!-- <option value="0">All Time</option> -->
                                            <option value="1">Today</option>
                                            <option value="2">This week</option>
                                            <option value="3">This Month</option>
                                            <option value="4"> This Year</option>
                                            <option value="5">Custom Range</option>
                                        </select>
                                        <div class="form-group" v-if="showFilters">
                                
                                                <date-picker v-if="filterForm.search_by_etd == 5" format="MM/DD/YYYY" @change="searchDate()"
                                                            v-model="filterForm.date_range_etd" range></date-picker>
                                            
                                        </div>
                                    </template>
                                    <template v-if="selectFilter == 9">
                                        <select class="form-control" v-model="filterForm.search_by_eta" @change="searchDateEta()">
                                            <option :value="null">Time Frame</option>
                                            <!-- <option value="0">All Time</option> -->
                                            <option value="1">Today</option>
                                            <option value="2">This week</option>
                                            <option value="3">This Month</option>
                                            <option value="4"> This Year</option>
                                            <option value="5">Custom Range</option>
                                        </select>
                                        <div class="form-group" v-if="showFiltersEta">
                                
                                                <date-picker v-if="filterForm.search_by_eta == 5" format="MM/DD/YYYY" @change="searchDateEta()"
                                                            v-model="filterForm.date_range_eta" range></date-picker>
                                            
                                        </div>
                                    </template>
                                    
                                </div>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="table-responsive product-create ">
                    <table class="table table-nowrap table-bordered align-middle table-custom shipment-table mb-0">
                        <thead>
                        <tr>
                            <th>Shipment Id
                            <span class="shortfl">
                            <a :class="{
                                active:sortId == 'asc'
                            }" @click="sortTableData('id','asc')" href="javascript:void(0)"><i class="ri-arrow-up-line"></i></a>
                            <a 
                            :class="{
                                active:sortId == 'desc',

                            }"
                            @click="sortTableData('id','desc')" href="javascript:void(0)"> <i class="ri-arrow-down-line"></i></a>
                            </span>
                            </th>
                            <th>Order No.</th>
                            <th>Shipping Method</th>
                            <th>Shipping Type</th>
                            <th>Final Destination</th>
                            <th>MBL NO.</th>
                            <!--<th style="width: 120px">HBL</th>-->
                            <th>Carrier</th>
                            <th>ETD
                            <span class="shortfl">
                            <a :class="{
                                active:sortEtd == 'asc'
                            }" @click="sortTableData('etd','asc')" href="javascript:void(0)"><i class="ri-arrow-up-line"></i></a>
                            <a 
                            :class="{
                                active:sortEtd == 'desc'
                            }"
                            @click="sortTableData('etd','desc')" href="javascript:void(0)"> <i class="ri-arrow-down-line"></i></a>
                            </span>
                            </th>
                            <th>Status</th>
                            
                            <th style="width: 170px;">ETA
                            <span class="shortfl">
                            <a :class="{
                                active:sortEta == 'asc'
                            }" @click="sortTableData('eta','asc')" href="javascript:void(0)"><i class="ri-arrow-up-line"></i></a>
                            <a :class="{
                                active:sortEta == 'desc'
                            }" @click="sortTableData('eta','desc')" href="javascript:void(0)"> <i class="ri-arrow-down-line"></i></a>
                            </span>
                            </th>
                            
                            <!-- <th>Delivered to</th> -->
                            <!-- <th>Notes</th> -->
                            <!-- <th style="width: 120px">Action </th> -->
                        </tr>
                        </thead>
                        <template v-if="customerData.data.length > 0">
                            <template  v-for="(customer, index) in customerData.data">
                                <tr :id="customer.id">
                                    <td><router-link
                                                    :to="{name: 'purchaseOrderShowShipment', params: {id: customer.purchase_order_id,shipId:customer.id}}"
                                                    class="view-ship" title="Details Product" :data-id="customer.id">{{customer.id}}</router-link></td>
                                   <td>{{customer.order.order_number }}</td>
                                   
                                    <td><template v-if="customer.carrier_type === 1"
                                            >Air</template
                                        >
                                        <template v-else>Ocean</template>
                                    </td>
                                    <td>{{customer.shipment_type}}</td>
                                    <td>{{customer.final_destination}}</td>
                                    <td>{{customer.tracking_no}}</td>
                                    <!--<td>{{customer.hbl_number}}</td>-->
                                    
                                    <td>{{customer.carrier_company}}</td>
                                    <td>
                                        {{ formatDate(customer.eta_departure) }}
                                    </td>
                                    <td><span
                                            v-if="customer.status === 1"
                                            class="not-initiated"
                                        >
                                            Not initiated
                                        </span>
                                        <span
                                            v-else-if="customer.status === 2"
                                            class="dhipped"
                                        >
                                            Shipped
                                        </span>
                                        <span
                                            v-else-if="customer.status === 3"
                                            class="in-iransit"
                                        >
                                            In Transit
                                        </span>
                                        <span
                                            v-else-if="customer.status === 4"
                                            class="delivered"
                                        >
                                            Delivered
                                        </span>
                                    </td>
                                    
                                    <td>
                                        {{ formatDate(customer.eta_arrival) }} 
                                        <template v-if="getDateFifference(customer.eta_arrival) > 0">
                                            <span class="text-success"><i class="ri-arrow-up-s-fill"></i>{{ getDateFifferenceData(customer.eta_arrival) }}days</span>
                                        </template>
                                        <template v-else>
                                            <span class="text-danger"><i class="ri-arrow-down-s-fill"></i>{{ getDateFifferenceData(customer.eta_arrival) }}days</span>
                                        </template>
                                        
                                    </td>

                                    
                                    <!-- <td>{{customer.destination}}</td> -->
                                    <!-- <td>{{customer.notes}}</td>
                                    
                                    <td>
                                        <router-link
                                                    :to="{name: 'purchaseOrderShowShipment', params: {id: customer.purchase_order_id,shipId:customer.id}}"
                                                    class="btn view-btn" title="Details Product" :data-id="customer.id">
                                                    <i class="ri-eye-line"></i></router-link>
                                        
                                    </td> -->
                                </tr>
                            </template>
                        </template>
                        <template v-else>
                            <tr><td colspan="8" style="text-align:center;">No records found</td></tr>
                        </template>
                    </table>

                    <div class="btnrow text-left">
                        <div class="overflow-auto mb-3">
                            <b-pagination
                                v-model="current_page"
                                :total-rows="total"
                                :per-page="per_page"
                            ></b-pagination>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>


</div>


    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import moment from "moment";
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    name: "ProductList",
    components: {
        DatePicker
    },
    props: ['bus'],
    created() {
        if(localStorage.getItem('token')){
            console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.setSuccessMessage(null);
        this.getCustomers();
    },
    mounted() {
        //  if(this.status_filter) {
        //     this.filterForm.status_filter = this.status_filter;
            
        // }
        //  if(this.customer_filter) {
        //     this.filterForm.customer_filter = this.customer_filter;
           
        // }
        // if(this.order_number) {
        //     this.filterForm.order_number = this.order_number;
            
        // }
        //  if(this.vendor_filter) {
        //     this.filterForm.vendor_filter = this.vendor_filter;
            
        // }
        // if(this.search_by_date) {
        //     this.filterForm.search_by_date = this.search_by_date;
            
        // }
        // if(this.date_range) {
        //     this.filterForm.date_range = this.date_range;
            
        // }

        this.bus.$on('getCustomers', this.getCustomers)
    },
    data(){
        return {
            sortId:'',
            sortEta:'',
            sortEtd:'',
            showFilters: true,
            showFiltersEta: true,
            filterData: {
                search: null,
                ship_method: null,
                carrier: null,
                search_by_etd: null,
                search_by_eta: null,
                purchase_search: null,
                search_saleuser_id: null,
                search_vendor_id: null,
                search_added_user_id: null,
                search_by_etd: "5",
                search_by_eta: "5",
                search_status_Id: null,
                date_range: null,
                date_range_etd: null,
                date_range_eta: null,
            },
            optionsVendor:[],
            selectFilter:1,
            selected:[],
            options:[
                // { label: 'Select More Column', id: 0 },
                { label: 'General phone number', id: 1 },
                { label: 'Billing email', id: 2 },
                { label: 'Total number of quotes', id: 3 },
                { label: 'Total number of orders', id: 4 },
            ],
            customerData:{
                data:[]
            },
            shipment_last:0,
            shipment_updated_eta:0,
            shipment_arriving:0,
            shipment_wating_pickup:0,
            current_page:1,
            per_page:10,
            total:0,
             filterForm: {
                search: null,
                ship_method: null,
                carrier: null,
                search_by_etd: null,
                search_by_eta: null,

                search_filter: null,
                status_filter: '',
                customer_filter:null,
                order_number:null,
                vendor_filter:null,
                
                shipment_number:null,
                search_by_etd: "5",
                search_by_eta: "5",
                search_status_Id: null,
                date_range: null,
                date_range_etd: null,
                date_range_eta: null,
                customer_id: null,
                vendor_id: null,
            },
            showModal: false,
            deleteId: null,
            csv_file: null,
            uploadPercent: 0,
            showUploadProgress: false,
            processingUpload: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        // updatePagination(){
        //     if(this.current_page != 1){
        //         this.getCustomers();
        //     }
        // },
        sortTableData(field,sort){
            


            if(field == 'id'){
                this.sortId = sort;
            }

            if(field == 'etd'){
                this.sortEtd = sort;
            }

            if(field == 'eta'){
                 this.sortEta = sort;
            }
            
            console.log("field",field);
            console.log("sort",sort);
            this.getCustomers();

        },
        searchDate() {
            this.showFilters = true;
            //this.bus.$emit('getOrders')
        },
        searchDateEta() {
            this.showFiltersEta = true;
            //this.bus.$emit('getOrders')
        },
        onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            // fetch(
            //     `https://api.github.com/search/repositories?q=${escape(search)}`
            // ).then(res => {
            //     res.json().then(json => (vm.options = json.items));
            //     loading(false);
            // });

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('customers.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Length",allData,allData.length);
                    vm.options = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        onVendorSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchVendor(loading, search, this);
            }
        },
        searchVendor(loading, search, vm) {
            
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendors.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Length",allData,allData.length);
                    vm.optionsVendor = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        getDateFifference(etaDate){


            var now = moment(new Date()),
            end = moment(etaDate),
            days = end.diff(now, 'days');

             
            return days;
            // let a = moment().format("YYYY-MM-DD");
            // let b = moment(etaDate).format("YYYY-MM-DD");
            // console.log("date a ",a);
            // console.log("date b ",b);
            // console.log("a.diff(b, 'days')",a.diff(b, 'days'))
            //return a.diff(b, 'days') // 1

        },
        getDateFifferenceData(etaDate){
            var now = moment(new Date()),
            end = moment(etaDate),
            days = end.diff(now, 'days');

             
             if(moment(etaDate).isValid()){
                let data = days;
                
               return Math.abs(days)
             }
             else{
                return "";
             }
            
        },
        getCustomers() {

            console.log("customer filter ",this.filterForm);
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('po.all-shipping-list',{page: this.current_page,
            order_number: this.filterForm.order_number,
            search_filter:this.filterForm.search,
            //status_filter:this.filterForm.status_filter,
            customer_filter:this.filterForm.customer_id,
            shipment_number:this.filterForm.shipment_number,
            vendor_filter:this.filterForm.vendor_id,
            ship_method:this.filterForm.ship_method,
            search_by_etd:this.filterForm.search_by_etd,
            search_by_eta:this.filterForm.search_by_eta,
            carrier:this.filterForm.carrier,
            date_range_etd:this.filterForm.date_range_etd,
            date_range_eta:this.filterForm.date_range_eta,
            sort_id:this.sortId,
            sort_eta:this.sortEta,
            sort_etd:this.sortEtd,
            //date_range:this.filterForm.date_range
            
            } ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    console.log("all shipping data ",data);
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage != null){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        console.log("ddddd",data);
                        this.shipment_last = data.shipment_last;
                        this.shipment_updated_eta = data.shipment_updated_eta;
                        this.shipment_arriving = data.shipment_arriving;
                        this.shipment_wating_pickup = data.shipment_wating_pickup;

                        this.current_page = data.data.current_page;
                        this.per_page = data.data.per_page;
                        this.total = data.data.total;
                        //this.setCustomers(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return index;
        },
        handleFileUpload(){
            this.csv_file = this.$refs.csv_file.files[0];
        },
        showDelete(id) {
            this.deleteId = id;
            $('#deleteModal').modal('show');
        },
        hideDelete() { $('#deleteModal').modal('hide'); this.deleteId = null; },
        deleteCustomer() {
            if(this.deleteId) {
                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('customers.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 5000);
                            self.deleteId = null;
                            self.getCustomers();
                            $('#deleteModal').modal('hide');
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            }
        }
    },
    watch: {
        selectFilter: {
            handler: function(value) {
               // console.log("selectFilter ",value);
               this.filterForm = {
                    search: null,
                    ship_method: null,
                    carrier: null,
                    search_by_etd: null,
                    search_by_eta: null,

                    search_filter: null,
                    status_filter: '',
                    customer_filter:null,
                    order_number:null,
                    vendor_filter:null,
                    
                    shipment_number:null,
                    search_by_etd: "5",
                    search_by_eta: "5",
                    search_status_Id: null,
                    date_range: null,
                    date_range_etd: null,
                    date_range_eta: null,
                    customer_id: null,
                    vendor_id: null,
                }
            }
        },
        current_page: {
            handler: function(value) {
                    this.getCustomers();
                console.log("watch ",value);
                // this.fetchData().catch(error => {
                // console.error(error)
                // })
            }
        },
        selected: {
            handler: function(selectedVal) {
                this.getCustomers();
                console.log("watch ",selectedVal);

            }
        },
        customer_filter: {
            handler: function (value) {
                this.filterForm.customer_filter = value;
            }
        },
        "filterForm.search": {
            handler: function (value) {
                this.getCustomers();
                console.log("filterForm.search",this.filterForm.search);
            }
        },
        
        "filterForm.ship_method": {
            handler: function (value) {
                this.getCustomers();
                console.log("filterForm.ship_method",this.filterForm.vendor_id);
            }
        },
        "filterForm.vendor_id": {
            handler: function (value) {
                this.getCustomers();
                console.log("filterForm.vendor_id",this.filterForm.vendor_id);
            }
        },
        "filterForm.customer_id": {
            handler: function (value) {
                this.getCustomers();
                console.log("filterForm.customer_id",this.filterForm.customer_id);
                //this.filterForm.vendor_filter = value;
            }
        },
        "filterForm.shipment_number": {
            handler: function (value) {
                this.getCustomers();
                console.log("filterForm.shipment_number",this.filterForm.shipment_number);
                //this.filterForm.shipment_number = value;
            }
        },
        "filterForm.order_number": {
            handler: function (value) {
                this.getCustomers();
                console.log("filterForm.order_number",this.filterForm.order_number);
                //this.filterForm.order_number = value;
            }
        },
         "filterForm.date_range_etd": {
            handler: function (value) {
                console.log("filterData.date_range_etd");
                this.filterForm.date_range_etd = value;
                this.getCustomers();
            }
        },
        "filterForm.date_range_eta": {
            handler: function (value) {
                console.log("filterData.date_range_eta");
                this.filterForm.date_range_eta = value;
                this.getCustomers();
            }
        },
        "filterForm.carrier": {
            handler: function (value) {
                
                this.getCustomers();
            }
        },
         search_by_date: {
            handler: function (value) {
                this.filterForm.search_by_date = value;
            }
        },
        status_filter: {
            handler: function (value) {
                this.filterForm.status_filter = value;
            }
        },
        "filterForm.search_by_etd": {
            handler: function (value) {
                if( value != 5){
                    if(value != null){
                        this.getCustomers();   
                    }
                     
                }
                console.log("filterData.search_by_etd",value);
                
            }
        },
        "filterForm.search_by_eta": {
            handler: function (value) {
                if( value != 5){
                    if(value != null){
                        this.getCustomers();   
                    }
                     
                }
                console.log("filterData.search_by_eta",value);
                
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
.select2-selection {
    border-radius: 0px !important;
    text-align: left !important;
}
.select2-dropdown {
    border-radius: 0px !important;
}
</style>
